import { render, staticRenderFns } from "./FailureReason.vue?vue&type=template&id=4defbbb6&"
import script from "./FailureReason.vue?vue&type=script&lang=js&"
export * from "./FailureReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports